import React from 'react'
// components
import Accounts from 'components/PageComponents/Settings/Account/Register'
import AccountsPageAPI from './layers/API'
import TableManagementProvider from 'containers/Search/layers/BL'

const AccountsContainer: React.FC = () => (
  <TableManagementProvider>
    <AccountsPageAPI>
      <Accounts />
    </AccountsPageAPI>
  </TableManagementProvider>
)

export default AccountsContainer
